import React, {useState} from 'react'
import { Col } from 'react-bootstrap'
import Description from './description'
import SearchField from '../../../universal/search-content-field/search-content-field.component'
import Table from './table'

import './style.scss';
import { UpperRow } from '../../../library/upper-row'

const Index = ({maintainLayout}) => {

	const [searchQuery, setSearchQuery] = useState("");

	const searchList = e => {
        setSearchQuery(e.target.value);
	}

	return(
		<Col md={5} className="dashboard-single-list-left-container">
			<Col className="inner-dashboard-single-list-left-container">
                <UpperRow title="Alle bedrifter"/>
				<Description/>
				<SearchField searchQuery={searchQuery} handleSearch={searchList}/>
				<Table maintainLayout={maintainLayout} searchQuery={searchQuery}/>
			</Col>
		</Col>
	)
}

export default Index